import {styled} from '@mui/material'

export const ImagesStyle = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8),
  alignItems: 'flex-end'
}))
